function template(data) {
  return `
    <cms-made-with
      link-href="${data.url}"
      link-title="${data.buttonText}"
      logo-src="${data.img}"
    ></cms-made-with>
  `.trim();
}

export default template;
